import React, { useLayoutEffect, useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { BorrowerLeadGenerationTool } from "borrower-lead-generation-tool";
import { getSwmcReferralLink } from "../../utils";
import loanOfficers from '../Hero/loanOfficers.json';

import StyledForm from "./styles";

export default function Form({
  mloData,
  parentClass,
  node,
  formRef,
  handleCloseModal,
  customDesigns,
  commonContent
}) {
  const mloID = mloData?.loID || "";
  const mloEmail = mloData?.email || "";
  const mloCompanyCode = mloData?.companyCode || "";
  const mloCustomReatorSection = customDesigns?.realtorSection || null;
  const trudisclaimer = commonContent?.disclaimer?.trudisclaimer || "";
  const trudisclaimerlink = commonContent?.disclaimer?.trudisclaimerlink || "";
  const companydisclaimer = commonContent?.disclaimer?.companydisclaimer || "";
  const companydisclaimerlink = commonContent?.disclaimer?.companydisclaimerlink || "";
  const [showHeader, setShowHeader] = useState(true);

  // Check for success screen
  useEffect(() => {
    const checkForSuccessScreen = () => {
      // Look for the success reference number element by checking text content
      const referenceNumberElements = document.querySelectorAll('.text-blue');
      let foundSuccessScreen = false;
      
      // Check if any of the elements contain the reference number text
      referenceNumberElements.forEach(element => {
        if (element.textContent.includes('Your Reference Number is')) {
          foundSuccessScreen = true;
        }
      });
      
      // Also check for continue application element
      const continueApplicationElement = document.getElementById('continue-application');
      
      if (foundSuccessScreen || continueApplicationElement) {
        setShowHeader(false);
      } else {
        setShowHeader(true);
      }
    };

    // Initial check
    checkForSuccessScreen();
    
    // Set up a MutationObserver to detect DOM changes
    const observer = new MutationObserver(checkForSuccessScreen);
    
    // Observe the entire document body for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    return () => {
      // Clean up the observer on component unmount
      observer.disconnect();
    };
  }, []);

  useLayoutEffect(() => {
    const timer = setTimeout(() => {
      const onFormMount = () => {
        // Map of input selectors to their placeholder text
        const placeholderMap = {
          'input[name="firstName"]': "Your First Name",
          'input[name="lastName"]': "Your Last Name",
          'input[name="email"]': "Email Address",
          'input[name="phone"]': "Your Phone Number",
          'textarea[name="message"]': "How Can We Help?",
          'textarea': "How Can We Help?", // Fallback for textarea
          '.form-control[type="text"]:nth-child(1)': "Your First Name",
          '.form-control[type="text"]:nth-child(2)': "Your Last Name",
          '.form-control[type="email"]': "Email Address",
          '.form-control[type="tel"]': "Your Phone Number"
        };
        
        if (node) {
          // Remove any existing custom labels first to avoid duplicates
          const existingLabels = document.querySelectorAll(`${parentClass} .custom-label-form`);
          existingLabels.forEach(label => {
            label.remove();
          });
          
          // Try direct selectors first
          Object.entries(placeholderMap).forEach(([selector, placeholder]) => {
            const inputs = document.querySelectorAll(`${parentClass} ${selector}`);
            
            inputs.forEach(input => {
              const parent = input.closest('.form-group') || input.parentNode;
              
              if (parent) {
                const d = document.createElement("div");
                d.setAttribute("class", "custom-label-form");
                d.innerText = placeholder;
                
                // Add the label to the form group
                parent.appendChild(d);
                
                // Add event listeners to handle focus and blur events
                input.addEventListener('focus', () => {
                  d.classList.add('active');
                });
                
                input.addEventListener('blur', () => {
                  if (input.value === '') {
                    d.classList.remove('active');
                  }
                });
                
                // Handle pre-filled inputs
                if (input.value !== '') {
                  d.classList.add('active');
                }
              }
            });
          });
          
          // Specifically target the message/comment field which might have a different structure
          const messageFields = document.querySelectorAll(`${parentClass} textarea, ${parentClass} [name="message"], ${parentClass} [name="comments"]`);
          
          if (messageFields.length > 0) {
            messageFields.forEach(field => {
              const parent = field.closest('.form-group') || field.parentNode;
              
              if (parent) {
                // Check if we already added a label (from the previous loop)
                const existingLabel = parent.querySelector('.custom-label-form');
                
                if (!existingLabel) {
                  const d = document.createElement("div");
                  d.setAttribute("class", "custom-label-form");
                  d.innerText = "How Can We Help?";
                  
                  // Position the label appropriately for textareas
                  d.style.top = "20px"; // Adjust this value as needed
                  
                  // Add the label to the form group
                  parent.appendChild(d);
                  
                  // Add event listeners to handle focus and blur events
                  field.addEventListener('focus', () => {
                    d.classList.add('active');
                  });
                  
                  field.addEventListener('blur', () => {
                    if (field.value === '') {
                      d.classList.remove('active');
                    }
                  });
                  
                  // Handle pre-filled inputs
                  if (field.value !== '') {
                    d.classList.add('active');
                  }
                }
              }
            });
          }
          
          // Fallback to the original approach if needed
          if (document.querySelectorAll(`${parentClass} .custom-label-form`).length === 0) {
            const formGroups = document.querySelectorAll(
              `${parentClass} .blg-row-1 .form-group`
            );
            
            const placeholders = [
              "Your First Name",
              "Your Last Name",
              "Email Address",
              "Your Phone Number",
              "How Can We Help?"
            ];

            formGroups.forEach((group, i) => {
              if (i < placeholders.length) {
                const input = group.querySelector('.form-control');
                
                if (input) {
                  const d = document.createElement("div");
                  d.setAttribute("class", "custom-label-form");
                  d.innerText = placeholders[i];
                  
                  // Add the label to the form group
                  group.appendChild(d);
                  
                  // Add event listeners to handle focus and blur events
                  input.addEventListener('focus', () => {
                    d.classList.add('active');
                  });
                  
                  input.addEventListener('blur', () => {
                    if (input.value === '') {
                      d.classList.remove('active');
                    }
                  });
                  
                  // Handle pre-filled inputs
                  if (input.value !== '') {
                    d.classList.add('active');
                  }
                }
              }
            });
          }

          // Check if success screen is present immediately
          const referenceNumberElements = document.querySelectorAll('.text-blue');
          referenceNumberElements.forEach(element => {
            if (element.textContent.includes('Your Reference Number is')) {
              setShowHeader(false);
            }
          });
        }
      };
    
      onFormMount();
    }, 500); 

    return () => clearTimeout(timer);
  }, [node, parentClass]);

  return (
    <StyledForm>
      <div className="form-bg mt-0">
        <div
          role="button"
          aria-label="Close"
          onClick={handleCloseModal}
          className="close-button"
        >
          <strong>+</strong>
        </div>
        <Container>
          <Row>
            <Col className="wholeform">
              {node && showHeader && (
                <header>
                  <h1 className="form-header">Contact Me</h1>
                  <h2 className="form-subheader">
                    Get Started In Less Than 60 Seconds...
                  </h2>
                </header>
              )}

              <div className="formBody">
              {mloData && (
  <BorrowerLeadGenerationTool
    showCustomizeLOApplyNowUrl
    ref={formRef}
    loanOfficerEmail={mloData.email}
    leadSource="SELF"
    branch="764"
    mainBtnName="Get Started"
    loanOfficerUid={mloData.loID}
    loID={mloData.loID}
  />
)}
              </div>
            </Col>
          </Row>

          <Row>
            <Col>
              <div className="fine-print-pad">
                <p className="fine-print">
                  *Visit{" "}
                  <a
                    aria-label="Click here to read Tru-Terms"
                    href={getSwmcReferralLink(
                      trudisclaimerlink,
                      mloID
                    )}
                    target="_blank"
                    rel="noreferrer"
                    className="fine-print-link"
                  >
                    {trudisclaimer}
                  </a>{" "}
                  for TRU Approval® terms and conditions.
                </p>
                {mloCustomReatorSection ? (
                  <p className="fine-print">
                    Realtor® is a registered trademark of National Association
                    of Realtors®.
                  </p>
                ) : null}
                <p className="fine-print">
                  **Visit{" "}
                  <a
                    aria-label="Click here to read swmc.com/disclaimer"
                    href={getSwmcReferralLink(
                      companydisclaimerlink,
                      mloID
                    )}
                    target="_blank"
                    rel="noreferrer"
                    className="fine-print-link"
                  >
                    {companydisclaimer}
                  </a>{" "}
                  for terms and limitations of the 100% Trusted Warranty.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </StyledForm>
  );
}